import { useModuleBEM } from "@b2bportal/core-themes";
import { getPassengerType } from "@b2bportal/core-utilities";
import { useI18nContext } from "@hopper-b2b/i18n";
import type { ITraveler } from "@hopper-b2b/types";
import { TravelerDelete } from "@tenant/traveler";
import { Button, ButtonTypeEnum } from "@tenant/ui";
import styles from "./styles.module.scss";
import { getGuestTypeString } from "@/modules/checkout";

type CreateTravelerItemProps = {
  traveler: ITraveler;
  id: string;
  /** Id placed on the traveller name/type text so the radio can name itself. */
  labelId?: string;
  disabled: boolean;
  handleEdit: (travelerId: string) => void;
  handleDelete: (travelerId: string) => void;
};

export const TravelerItemComponent = ({
  traveler,
  handleEdit,
  handleDelete,
  disabled,
  id,
  labelId,
}: CreateTravelerItemProps) => {
  const { t } = useI18nContext();
  const [, cn] = useModuleBEM(styles, "TravelerList");

  const { first, last, middle = "" } = traveler.name;
  const givenName = [first, middle, last].filter(Boolean).join(" ");

  return (
    <label className={cn("traveler-option")} htmlFor={id}>
      <div id={labelId} className={cn("traveler")}>
        <span
          id={`traveler-${traveler.id}-name`}
          className={cn("traveler-name")}
        >
          {givenName}
        </span>
        <span className={cn("traveler-type")}>
          {getGuestTypeString(getPassengerType(traveler), t)}
        </span>
      </div>
      {!disabled ? (
        <div className={cn("traveler-actions")}>
          <Button
            className={cn("traveler-button", { edit: true })}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              handleEdit(traveler.id);
            }}
            buttonType={ButtonTypeEnum.Secondary}
            type="button"
            aria-label={t("travelerListActions.edit", { name: givenName })}
          >
            {t("edit")}
          </Button>
          <TravelerDelete
            traveler={traveler}
            onDelete={() => handleDelete(traveler.id)}
            trigger={
              <Button
                className={cn("traveler-button", { delete: true })}
                buttonType={ButtonTypeEnum.Secondary}
                type="button"
                onClick={(e) => {
                  e.stopPropagation();
                }}
                aria-label={t("travelerListActions.delete", {
                  name: givenName,
                })}
              >
                {t("delete")}
              </Button>
            }
          />
        </div>
      ) : null}
    </label>
  );
};
